import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { SystemNotificationsViewRoutes } from "../../../routes/HomeRoutes/SystemNotificationsRoutes";

export const SystemNotificationLayout = () => (
    <SwitchRoute routes={SystemNotificationsViewRoutes}/>
);